module.exports = __webpack_public_path__ + "static/media/seat-sm.ba2dab5a.svg";